import { FetchClient } from "@/core/client/fetch_client"
import { getService } from "hooks/useStartup"
import { ResponseModel } from "@/core/generated/api/models/response_model"
import { ResponseSerializer } from "@/core/generated/api/response_serializer"
import { useState } from "react"
import { StatusCode } from "@/core/generated/api/enums/status_code"
import { CreateUser } from "../models/createUser"

export const useSignupUser = () => {
  const [data, setData] = useState<ResponseModel | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [code, setCode] = useState<number | null>(null)
  const [message, setMessage] = useState<string>("")

  const signUp = async (args: CreateUser) => {
    setLoading(true)
    let response: ResponseModel | null = null

    try {
      const client: FetchClient = getService(FetchClient)
      response = await client.postAsync(`/user/signup`, args)

      if (response !== null) {
        const model: ResponseModel | null =
          ResponseSerializer.deserialize<ResponseModel>(response)
        if (model !== null) {
          setData(model)
          setCode(response.code)
        }
      } else {
        setCode(StatusCode.BadRequest)
      }
    } catch (err) {
      console.error(err)
      setCode(StatusCode.BadRequest)
    } finally {
      setMessage(response?.message)
      setLoading(false)
    }

    return response
  }

  return {
    data,
    loading,
    code,
    message,
    signUp,
  }
}
